import React, { useContext, useState } from 'react';

import Layout from '../../common_components/Layout';
import { RadioBtn } from '../components/Inputs';
import { AppContext } from '../contexts';
import {
  AlertFormSubmitted,
  AlertTrainingTaskCompleted,
} from '../components/Alerts';
import { triggerModalUpdate } from '../../TaskModal';

export default function Normalization({ data, isCompleted }) {
  const app = useContext(AppContext);
  const stepsApi = app.APIs.steps;
  const [formState, setFormState] = useState(undefined);
  const estimatedNormalizationTime = app.estimatedTimes.normalization;

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    setFormState('awaiting-response');
    stepsApi.normalization(app.activeProject.id, data).then((projectData) => {
      if (projectData) {
        app.setActiveProject(projectData);
        setFormState('response-ok');
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        triggerModalUpdate({ status: 200 });
      }
    });
  };

  // load saved values if was already submitted
  const savedVariant = data?.variants?.find(({ selected }) => selected);
  const savedVariable = data?.variables?.find(({ selected }) => selected);
  const formWasAlreadySubmitted = savedVariant || savedVariable;

  return (
    <Layout
      title="Normalizacja"
      mainContent={
        <>
          <p className="text-left sm:text-justify columns-2 gap-16">
            Normalizacja (meteorologiczna) to proces, który pozwala usunąć wpływ
            zmiennych meteorologicznych oraz typowych sezonowych wzorców z
            szeregów czasowych stężeń zanieczyszczeń powietrza. W efekcie
            otrzymujemy dane, które lepiej odzwierciedlają rzeczywiste zmiany
            emisji, a nie zmienność wynikającą z warunków atmosferycznych.
          </p>
          {isCompleted && (
            <AlertTrainingTaskCompleted
              mainMessage={'Normalizacja danych zakończona!'}
              subMessage={
                'Normalizacja danych zakończyła się powodzeniem. Możesz teraz przejść dalej.'
              }
              additionalContent={<ProceedButton />}
            />
          )}
          {!isCompleted &&
            (formState == 'response-ok' || formWasAlreadySubmitted) && (
              <AlertFormSubmitted
                estimatedTrainingTime={estimatedNormalizationTime}
              />
            )}
          <form method="POST" className="w-full" onSubmit={handleFormSubmit}>
            <fieldset
              className="flex flex-col justify-center items-center gap-8 w-full"
              disabled={
                formState == 'response-ok' ||
                formState == 'awaiting-response' ||
                formWasAlreadySubmitted
              }
            >
              <div className="flex justify-center flex-col items-center">
                <h2>Wybierz wariant</h2>
                <p>
                  Wybierz wariant modelu statystycznego do przeprowadzenia
                  normalizacji dla substancji zanieczyszczającej. <br />
                  Zaleca się stosowanie modelu, który charakteryzuje się
                  najwyższą dokładnością prognozowania.
                </p>
                <div className="flex gap-12 mt-4">
                  {data?.variants?.map((variant, i) => (
                    <RadioBtn
                      label={variant.label}
                      onSelect={() => {}}
                      name="variant"
                      value={variant.name}
                      defaultChecked={
                        savedVariant
                          ? savedVariant.name == variant.name
                          : i == 0
                      }
                      key={variant.name}
                    />
                  ))}
                </div>
              </div>
              <button
                className={
                  formState == 'response-ok' ||
                  formState == 'awaiting-response' ||
                  formWasAlreadySubmitted
                    ? 'btn btn-disabled btn-lg btn-wide mt-10 opacity-50 cursor-not-allowed'
                    : 'btn btn-success btn-lg btn-wide mt-10'
                }
                type="submit"
                disabled={
                  formState == 'response-ok' ||
                  formState == 'awaiting-response' ||
                  formWasAlreadySubmitted
                }
              >
                Uruchom
              </button>
            </fieldset>
          </form>
        </>
      }
    ></Layout>
  );
}

function ProceedButton() {
  const app = useContext(AppContext);
  const handleModelEvaluationBtn = () => {
    app.setVisibleStep('tendencies');
  };

  return (
    <div className="btn btn-info" onClick={handleModelEvaluationBtn}>
      Tendencje
    </div>
  );
}
